import client from './client'

export const fetchHolidayRequests = (year?: string, month?: string) => {
  return client.get('/api/v1/holiday_requests', { params: { year: year, month: month } })
}

export const createHolidayRequest = (kind: number, year: number, month: number, day: number, reason: string) => {
  return client.post('/api/v1/holiday_requests', { kind: kind, year: year, month: month, day: day, reason: reason })
}

export const deleteHolidayRequest = (id: number) => {
  return client.delete(`/api/v1/holiday_requests/${id}`)
}

export const updateHolidayRequest = (id: number, status: number) => {
  return client.put(`/api/v1/holiday_requests/${id}`, { status: status })
}
